import { render, staticRenderFns } from "./Delegations.vue?vue&type=template&id=294f8982&lang=pug&"
import script from "./Delegations.vue?vue&type=script&lang=ts&"
export * from "./Delegations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports